import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { AbstractTuiControl } from '@taiga-ui/legacy';

/** TODO: не используется */
@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CounterComponent extends AbstractTuiControl<number> {
  /** Массив подписей */
  @Input() labels: string[] = [];

  /** Минимальное значение */
  @Input() min = 0;

  /** Максимальное значение */
  @Input() max = 10;

  /** Флаг, чтобы переопределять доступ к элементу, не зависимо от состояния формы */
  @Input() forceDisabled = false;

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): number {
    return 0;
  }

  changeValue(inc: number) {
    const tempValue = this.value + inc;

    if (tempValue < this.min || tempValue > this.max) {
      return;
    }

    this.value = tempValue;
  }
}
